export const getLeavingReasons = ()=>([
  {id: 1, title: "RETIREMENT"},
  {id: 2, title: "DEATH IN SERVICE"},
  {id: 3, title: "SUPERNNUATION"},
  {id: 4, title: "PERMANENT DISABLEMENT"},
  {id: 5, title: "CESSATION (SHORT SERVICE) - Any other reason"},
  {id: 6, title: "CESSATION (SHORT SERVICE) - The employee ill health"},
  {id: 7, title: "CESSATION (SHORT SERVICE) - The contraction or discontinuation of employer's business"},
  {id: 8, title: "CESSATION (SHORT SERVICE) - Other cause beyond the control of employee"},
])
